import { initializers } from 'linksoft'
import coordinatesImport from '../components/modules/coordinatesImport'
import redirect from '../components/modules/redirect'
import userAssignment from '../components/modules/userAssignment'
import switcher from '../components/switcher'
import changeFormAction from '../components/modules/changeFormAction'
import radioButtonDisableShareWithLabel from '../components/radioButtonDisableShareWithLabel'
import measurementTypeParameterSelect from '../components/modules/measurementTypeParameterSelect'
import closeModalOnValidationPassed from '../components/modules/closeModalOnValidationPassed'
import nominalProfileDataRefresh from '../components/modules/nominalProfileDataRefresh'
import axisChartsRefresh from '../components/modules/axisChartsRefresh'
import remoteModal from '../components/modules/remoteModal'
import select2Templates from './select2-templates'
import fireOnHide from './fire-on-hide'
import modalForChartDetail from '../components/modules/modalForChartDetail'
import spectrumColorPicker from '../components/modules/spectrumColorPicker'
import curvePointImport from '../components/modules/curvePointImport'
import chainageChartRefresh from '../components/modules/chainageChart/refresh'
import goToTopButton from '../components/modules/goToTopButton'

import { popperInitializer } from '../components/initializers/popper-tooltip'
import { warningThresholdEvaluatorInitializer } from '../components/initializers/warning-threshold-evaluator'
import { reactLazyInit } from '../components/initializers/react-lazy-init'
import { visibleOnSelect } from '../components/initializers/visible-on-select'
import { pdfJsInitializer} from '../components/initializers/pdf-js'

export default [
    initializers.ajax,
    initializers.tooltip,
    initializers.confirm,
    initializers.datepicker,
    initializers.autoQuery,
    initializers.dispatchAction,
    initializers.notify,
    initializers.clickOnEnter,
    visibleOnSelect,
    popperInitializer,
    pdfJsInitializer,
    warningThresholdEvaluatorInitializer,
    reactLazyInit,
    coordinatesImport,
    redirect,
    userAssignment,
    switcher,
    changeFormAction,
    radioButtonDisableShareWithLabel,
    measurementTypeParameterSelect,
    closeModalOnValidationPassed,
    nominalProfileDataRefresh,
    chainageChartRefresh,
    remoteModal,
    axisChartsRefresh,
    select2Templates,
    fireOnHide,
    modalForChartDetail,
    spectrumColorPicker,
    curvePointImport,
    goToTopButton
]


// WEBPACK FOOTER //
// ./App/config/initializers.js